import {charcoal} from '../../sass/v2/_exports.sass';

export const PlusIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3333 14.6667H17.3333V6.66667H14.6667V14.6667H6.66667V17.3333H14.6667V25.3333H17.3333V17.3333H25.3333V14.6667Z"
        fill={color}
      />
    </svg>
  );
};
